export default __webpack_public_path__ + "static/media/threeicon2.ca27ed45.png";